/* 130R · Kits por carro (/pages/kits-por-carro). Agente kit-finder, 19/10/2026.
   Jornada: carro (Meu carro ou Montadora → Modelo → Ano) → parte do carro → tipo de kit → cartões; busca livre;
   "Não achou?" em todo passo, com o WhatsApp levando o pedido, o carro e o chassi (o r130-chassi.js põe o chassi).

   DADOS (gerados por tools/site/kits_por_carro.py):
     assets/r130-kits-por-carro.json         índice: montadoras, modelos (anos e contagem), rótulos, versão;
     assets/r130-kits-por-carro-<grupo>.json kits, peças e aplicação por "MONTADORA|MODELO", sob demanda.
     Kit: {id, n (nome), c [[sku, qtd]], e (1 = em estoque), s [sistemas], t (tipo), tp [tipos], o (pedidos em 12 meses),
           f ('c' aplicação cadastrada | 'p' parcial | 'n' pelo nome), a [[handle, variante, preço em centavos, à venda 0/1, [modelos]]]}.
     Regra: o site nunca diz "serve". 'c' = "Aplicação cadastrada"; 'p' e 'n' = "Confirme pelo chassi". Kit sem anúncio: sem preço,
     "Pedir pelo WhatsApp".

   GANCHOS (não mexe neles, só usa): localStorage r130_garage {brand, model, year}; evento r130:garagem (Meu carro);
   [data-r130-garagem-rotulo] se atualiza pelo evento 'storage'; window.R130Carrinho.adicionar (abre a gaveta);
   window.R130Medicao.emitir. Eventos: kit_finder_passo, kit_finder_resultado, kit_finder_whatsapp, kit_finder_nao_achou
   e kit_adicionar (o mesmo nome do protótipo da página de produto).

   Endereço da tela: ?montadora=HYUNDAI&modelo=TUCSON&ano=2010&parte=susp_d&tipo=buchas_bandeja (ou &busca=...);
   o voltar do navegador volta um passo.

   PERGUNTAS GUIADAS (agente kit-guia, 19/10/2026; assets/r130-kits-guia.js e a seção r130-kits-guia): &guia=<respostas>
   liga o passo 'guia', desenhado pelo window.R130KitsGuia neste mesmo painel com o window.R130Kits (fim do arquivo).
   Depois de todo passo sai o evento 'r130:kits-passo'. Sem o guia carregado, nada muda. */
(function () {
  'use strict';
  var raiz = document.querySelector('[data-r130-kits]');
  if (!raiz || raiz.getAttribute('data-kits-pronto')) return;
  raiz.setAttribute('data-kits-pronto', '1');

  var FONE = raiz.getAttribute('data-fone') || '5511910801297';
  var LOJA = (raiz.getAttribute('data-loja') || location.origin).replace(/\/$/, '');
  var URL_INDICE = raiz.getAttribute('data-indice');
  var painel = raiz.querySelector('[data-kits-painel]');
  var boxCarro = raiz.querySelector('[data-kits-carro]');
  var trilha = raiz.querySelector('[data-kits-trilha]');
  var formBusca = raiz.querySelector('[data-kits-busca]');
  var campoBusca = raiz.querySelector('[data-kits-busca] input');
  var na = document.querySelector('[data-r130-kits-naoachou]');
  var POR_PAGINA = 24;
  var SECAO = 'localizador';
  var reduzir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var indice = null;
  var arquivos = {};
  var estado = { carro: null, s: null, t: null, q: '', todos: false, trocar: false, n: POR_PAGINA, origemCarro: '', guia: null };
  var garagemSemKit = null;
  var silencio = false;   // "Mostrar mais" redesenha a lista sem contar de novo o passo e o resultado

  /* ---------------- utilidades ---------------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function semAcento(s) { return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function chave(s) { return semAcento(s).toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function ico(nome) { var t = raiz.querySelector('template[data-kits-ico="' + nome + '"]'); return t ? t.innerHTML : ''; }
  function plural(n, um, varios) { return n + ' ' + (n === 1 ? um : varios); }
  function dinheiro(c) {
    try { return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(c / 100).replace(/ /g, ' '); }
    catch (e) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
  }
  function juntar(lista) { return lista.length <= 1 ? (lista[0] || '') : lista.slice(0, -1).join(', ') + ' e ' + lista[lista.length - 1]; }
  function faixaTexto(a, b) { return a === b ? String(a) : a + ' a ' + b; }
  function emitir(nome, campos) {
    if (silencio && (nome === 'kit_finder_passo' || nome === 'kit_finder_resultado')) return;
    try {
      if (window.R130Medicao && typeof window.R130Medicao.emitir === 'function') {
        window.R130Medicao.emitir(nome, Object.assign({ origem: 'pagina/' + SECAO, secao: SECAO }, campos || {}));
      }
    } catch (e) {}
  }
  function linkWa(texto) { return 'https://wa.me/' + FONE + '?text=' + encodeURIComponent(texto); }

  // Radical para a busca: "buchas" → "bucha", "coxins" → "coxim", "traseiro" → "traseir", "maiores" → "maior".
  function radical(w) {
    if (/^traseir/.test(w)) return 'traseir';
    if (/^(dianteir|frente$|frontal)/.test(w)) return 'dianteir';
    if (w.length > 4 && /oes$/.test(w)) return w.slice(0, -3) + 'ao';
    if (w.length > 3 && /ns$/.test(w)) return w.slice(0, -2) + 'm';
    if (w.length > 4 && /res$/.test(w)) return w.slice(0, -2);
    if (w.length > 4 && /ais$/.test(w)) return w.slice(0, -2) + 'l';
    if (w.length > 3 && /s$/.test(w)) return w.slice(0, -1);
    return w;
  }
  function palavras(t) { return semAcento(t).toLowerCase().split(/[^a-z0-9]+/).filter(Boolean).map(radical); }
  var VAZIAS = { de: 1, da: 1, do: 1, das: 1, dos: 1, e: 1, para: 1, pra: 1, kit: 1, kits: 1, o: 1, a: 1, os: 1, as: 1, com: 1,
    no: 1, na: 1, meu: 1, minha: 1, carro: 1, peca: 1, pecas: 1, um: 1, uma: 1 };

  /* ---------------- dados ---------------- */
  function pegarJson(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); });
  }
  function carregarIndice() {
    if (indice) return Promise.resolve(indice);
    return pegarJson(URL_INDICE).then(function (j) { indice = j; return j; });
  }
  function urlArquivo(nome) {
    var base = URL_INDICE.split('?')[0].replace(/r130-kits-por-carro\.json$/, nome);
    return base + '?v=' + encodeURIComponent(indice.versao || '');
  }
  function carregarArquivo(nome) {
    if (!arquivos[nome]) {
      arquivos[nome] = pegarJson(urlArquivo(nome)).then(function (d) {
        d.porKit = {};
        Object.keys(d.aplic || {}).forEach(function (k) {
          d.aplic[k].forEach(function (r) { (d.porKit[r[0]] = d.porKit[r[0]] || []).push([k, r[1], r[2], r[3]]); });
        });
        return d;
      });
      arquivos[nome].catch(function () { delete arquivos[nome]; });
    }
    return arquivos[nome];
  }
  function montadora(id) { return (indice.montadoras || []).filter(function (m) { return m.id === id; })[0] || null; }
  function modelo(mId, mdId) {
    var m = montadora(mId);
    return m ? (m.modelos.filter(function (x) { return x.id === mdId; })[0] || null) : null;
  }
  function nomeCarro(c, comMontadora) {
    if (!c) return '';
    var m = montadora(c.m), md = modelo(c.m, c.md);
    return ((comMontadora && m ? m.nome + ' ' : '') + (md ? md.nome : '') + (c.a ? ' ' + c.a : '') + (c.mt ? ' ' + c.mt : '')).trim();
  }
  function nomeModeloChave(k) {   // "HYUNDAI|TUCSON" → "Hyundai Tucson"
    var p = k.split('|'), m = montadora(p[0]), md = modelo(p[0], p[1]);
    return (m ? m.nome + ' ' : '') + (md ? md.nome : p[1]);
  }

  // Kits do carro escolhido: [{k, d, faixas: [[a, b, motor]]}] (faixas do modelo inteiro, para o cartão).
  function kitsDoCarro(c) {
    var m = montadora(c.m);
    if (!m) return Promise.resolve([]);
    return carregarArquivo(m.arquivo).then(function (d) {
      var linhas = d.aplic[c.m + '|' + c.md] || [];
      var por = {};
      linhas.forEach(function (r) { (por[r[0]] = por[r[0]] || []).push([r[1], r[2], r[3]]); });
      var out = [];
      Object.keys(por).forEach(function (i) {
        var fx = por[i];
        if (fx.some(function (r) { return r[0] <= c.a && c.a <= r[1]; })) out.push({ k: d.kits[i], d: d, faixas: fx, i: +i });
      });
      // Motor (decisão do Marcus, 19/10/2026): só ordena, nunca esconde. Bate (ou vale para qualquer motor) vem primeiro.
      var mtc = c.mt;
      if (mtc === undefined) {
        var gm = lerGaragem();
        mtc = gm && chave(gm.brand) === chave(c.m) && chave(gm.model) === c.md && (!gm.year || Number(gm.year) === c.a) ? (gm.motor || '') : '';
      }
      out.forEach(function (x) { x.motor = motorDoKit(x.faixas, c.a, mtc); });
      out.sort(function (x, y) { return (y.motor.rank - x.motor.rank) || (y.k.e - x.k.e) || (compravel(y.k) - compravel(x.k)) || (x.i - y.i); });
      return out;
    });
  }
  function compravel(k) { return (k.a || []).some(function (a) { return a[3]; }) ? 1 : 0; }
  // Motores da aplicação do kit no ano do carro e se batem com o motor do cliente (pela cilindrada: "3.3 V6" = "3.3").
  // rank 1: bate ou vale para qualquer motor (ou o cliente não informou); 0: cadastrado só para outro motor.
  function cilindradaDe(m) { var r = /(\d)\s*[.,]\s*(\d)/.exec(String(m || '')); return r ? r[1] + '.' + r[2] : ''; }
  function mesmoMotorKit(a, b) {
    var ca = cilindradaDe(a), cb = cilindradaDe(b);
    if (ca && cb) return ca === cb;
    var na = String(a || '').toUpperCase().replace(/[^A-Z0-9.]/g, ''), nb = String(b || '').toUpperCase().replace(/[^A-Z0-9.]/g, '');
    return !!na && !!nb && (na.indexOf(nb) === 0 || nb.indexOf(na) === 0);
  }
  function motorDoKit(fx, ano, mtc) {
    var lista = [], livre = false;
    (fx || []).forEach(function (r) {
      if (ano && !(r[0] <= ano && ano <= r[1])) return;
      var ms = String(r[2] || '').split(/,|\s+e\s+|\//).map(function (x) { return x.trim(); }).filter(Boolean);
      if (!ms.length) livre = true;
      ms.forEach(function (m) { if (lista.indexOf(m) === -1) lista.push(m); });
    });
    var bate = !mtc || livre || !lista.length || lista.some(function (m) { return mesmoMotorKit(m, mtc); });
    return { rank: bate ? 1 : 0, outro: !bate, motores: lista, cliente: mtc };
  }
  function anosComKit(c) {
    var m = montadora(c.m);
    if (!m) return Promise.resolve([]);
    return carregarArquivo(m.arquivo).then(function (d) {
      var anos = {};
      (d.aplic[c.m + '|' + c.md] || []).forEach(function (r) { for (var a = r[1]; a <= r[2]; a++) anos[a] = 1; });
      return Object.keys(anos).map(Number).sort(function (x, y) { return x - y; });
    });
  }

  /* ---------------- Meu carro (r130_garage) ---------------- */
  function lerGaragem() {
    try { var g = JSON.parse(localStorage.getItem('r130_garage')); return g && g.brand && g.model ? g : null; } catch (e) { return null; }
  }
  // O carro salvo no Meu carro, se houver kit para o modelo: {m, md, a}; senão guarda o rótulo para avisar.
  function carroDaGaragem() {
    var g = lerGaragem();
    garagemSemKit = null;
    if (!g) return null;
    var m = (indice.montadoras || []).filter(function (x) { return chave(x.id) === chave(g.brand); })[0];
    var md = m && m.modelos.filter(function (x) { return x.id === chave(g.model); })[0];
    if (!md) {
      garagemSemKit = (m ? m.nome + ' ' : '') + String(g.model) + (g.year ? ' ' + g.year : '');
      return null;
    }
    return { m: m.id, md: md.id, a: g.year ? Number(g.year) : null, mt: g.motor || '' };
  }
  function salvarGaragem(c) {
    var md = modelo(c.m, c.md);
    if (!md || !c.a) return;
    var g = lerGaragem();
    var mesmo = g && chave(g.brand) === chave(c.m) && chave(g.model) === c.md;
    if (mesmo && Number(g.year) === c.a && (c.mt === undefined || (g.motor || '') === c.mt)) return;
    var novo = { brand: c.m, model: mesmo ? g.model : md.nome.toUpperCase(), year: c.a };
    if (c.mt !== undefined) novo.motor = c.mt;          // motor escolhido no passo do carro (ou '' com o chassi)
    else if (mesmo && g.motor) novo.motor = g.motor;
    try { localStorage.setItem('r130_garage', JSON.stringify(novo)); } catch (e) { return; }
    // O "Meu carro" do header relê o carro no evento 'storage' (o mesmo de quando outra aba muda o carro).
    try { window.dispatchEvent(new StorageEvent('storage', { key: 'r130_garage' })); } catch (e) {}
    emitir('carro_salvo', { montadora: (montadora(c.m) || {}).nome, modelo: md.nome, ano: c.a });
  }

  /* ---------------- endereço ---------------- */
  function lerUrl() {
    var p = new URLSearchParams(location.search);
    return { m: p.get('montadora'), md: p.get('modelo'), a: Number(p.get('ano')) || null, s: p.get('parte'), t: p.get('tipo'),
      q: (p.get('busca') || '').slice(0, 80), todos: p.get('todos') === '1', trocar: p.get('trocar') === '1',
      g: p.has('guia') ? (p.get('guia') || '').slice(0, 300) : null };
  }
  function gravarUrl(modo) {
    var p = new URLSearchParams();
    if (estado.carro) { p.set('montadora', estado.carro.m); p.set('modelo', estado.carro.md); if (estado.carro.a) p.set('ano', estado.carro.a); }
    if (estado.trocar) p.set('trocar', '1');
    if (estado.guia != null) p.set('guia', estado.guia);
    if (estado.q) { p.set('busca', estado.q); if (estado.todos) p.set('todos', '1'); }
    else { if (estado.s) p.set('parte', estado.s); if (estado.t) p.set('tipo', estado.t); }
    var url = location.pathname + (p.toString() ? '?' + p.toString() : '');
    try { history[modo === 'push' ? 'pushState' : 'replaceState']({ r130kits: 1 }, '', url); } catch (e) {}
  }
  function aplicarUrl(u) {
    estado.carro = null;
    if (u.m && u.md && modelo(u.m, u.md)) {
      estado.carro = { m: u.m, md: u.md, a: u.a };
      var gu = lerGaragem();   // motor do "Meu carro", se for o mesmo carro
      if (gu && chave(gu.brand) === chave(u.m) && chave(gu.model) === u.md && (!gu.year || Number(gu.year) === u.a)) estado.carro.mt = gu.motor || '';
    }
    estado.s = u.s; estado.t = u.t; estado.q = u.q; estado.todos = u.todos; estado.trocar = u.trocar; estado.n = POR_PAGINA;
    estado.guia = u.g;
    if (campoBusca) campoBusca.value = estado.q;
  }

  /* ---------------- navegação ---------------- */
  function ir(mudanca) {
    Object.keys(mudanca).forEach(function (k) { estado[k] = mudanca[k]; });
    estado.n = POR_PAGINA;
    gravarUrl('push');
    render(true);
  }
  function passoAtual() {
    if (estado.q) return 'busca';
    if (!estado.carro || !estado.carro.a || estado.trocar) return 'carro';
    if (estado.guia != null && window.R130KitsGuia && window.R130KitsGuia.disponivel(indice)) return 'guia';
    if (!estado.s) return 'parte';
    if (!estado.t && estado.s !== 'todos') return 'tipo';
    return 'resultado';
  }
  function camposPasso() {
    var c = estado.carro, m = c && montadora(c.m), md = c && modelo(c.m, c.md);
    return { passo: passoAtual(), montadora: m ? m.nome : '', modelo: md ? md.nome : '', ano: c && c.a ? c.a : '',
      parte: estado.s || '', tipo: estado.t || '', origem_carro: estado.origemCarro || '' };
  }
  function focar(el, rolar) {
    if (!el) return;
    if (rolar) {
      var y = el.getBoundingClientRect().top + (window.pageYOffset || 0) - 110;
      if (y < (window.pageYOffset || 0) || el.getBoundingClientRect().top > window.innerHeight * 0.6) {
        try { window.scrollTo({ top: Math.max(0, y), behavior: reduzir ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, Math.max(0, y)); }
      }
    }
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function render(doUsuario) {
    atualizarCarroBox();
    atualizarTrilha();
    atualizarNaoAchou();
    painel.setAttribute('aria-busy', 'true');
    var p = passoAtual();
    var feito = p === 'busca' ? renderBusca() : p === 'carro' ? renderCarro() : p === 'parte' ? renderPartes()
      : p === 'tipo' ? renderTipos() : p === 'guia' ? window.R130KitsGuia.render(window.R130Kits) : renderResultado();
    return Promise.resolve(feito).then(function () {
      painel.setAttribute('aria-busy', 'false');
      if (p !== 'guia') emitir('kit_finder_passo', camposPasso());
      try { document.dispatchEvent(new CustomEvent('r130:kits-passo', { detail: { passo: p, guia: estado.guia != null } })); } catch (e) {}
      if (doUsuario) focar(painel.querySelector('[data-kits-foco]'), true);
    }).catch(function () {
      painel.setAttribute('aria-busy', 'false');
      painel.innerHTML = erroCarga();
    });
  }

  /* ---------------- topo: carro e trilha ---------------- */
  function atualizarCarroBox() {
    var c = estado.carro;
    if (!c || !c.a || estado.trocar) { boxCarro.hidden = true; boxCarro.innerHTML = ''; return; }
    boxCarro.hidden = false;
    boxCarro.innerHTML = ico('carro') + '<span class="r130-kits__carro-rot">Seu carro:</span> <span class="r130-kits__carro-nome">'
      + esc(nomeCarro(c, true)) + '</span>'
      + (window.R130Motor && !window.R130Motor.completo() ? '<button type="button" class="r130-kits__carro-trocar r130-kits__carro-motor" data-kits-acao="trocar">Informe o motor</button>' : '')
      + '<button type="button" class="r130-kits__carro-trocar" data-kits-acao="trocar">Trocar o carro</button>';
  }
  function atualizarTrilha() {
    var c = estado.carro, p = passoAtual(), itens = [];
    if (p === 'carro' || p === 'guia' || !c) { trilha.hidden = true; trilha.innerHTML = ''; return; }
    var nomeP = estado.s === 'todos' ? 'Todos os kits' : (estado.s ? indice.sistemas[estado.s] || estado.s : '');
    if (p === 'busca') {
      itens.push(['Partes do ' + nomeCarro(c), 'partes']);
      itens.push(['Busca', null]);
    } else {
      itens.push(['Partes do ' + nomeCarro(c), p === 'parte' ? null : 'partes']);
      if (estado.s) itens.push([nomeP, p === 'tipo' ? null : (estado.s === 'todos' ? null : 'tipos')]);
      if (estado.t) itens.push([indice.topicos[estado.t] || estado.t, null]);
    }
    trilha.hidden = false;
    trilha.innerHTML = '<ol>' + itens.map(function (it) {
      return '<li>' + (it[1] ? '<button type="button" data-kits-acao="' + it[1] + '">' + esc(it[0]) + '</button>'
        : '<span aria-current="step">' + esc(it[0]) + '</span>') + '</li>';
    }).join('') + '</ol>';
  }
  function linkNaoAchou() {
    return '<p class="r130-kits__naoachou-link">Não achou o seu kit? <a href="#r130-kits-naoachou" data-kits-acao="naoachou">Peça pelo WhatsApp</a></p>';
  }
  function dataLista() {
    var g = String(indice.gerado || '').slice(0, 10).split('-');
    return g.length === 3 ? '<p class="r130-kits__data">Lista de kits de ' + g[2] + '/' + g[1] + '/' + g[0] + '.</p>' : '';
  }
  function erroCarga() {
    return '<div class="r130-kits__vazio" data-kits-foco tabindex="-1"><p>Não conseguimos carregar a lista de kits agora. Tente de novo em instantes ou peça o kit pelo WhatsApp.</p>'
      + '<div class="r130-kits__vazio-acoes"><button type="button" class="r130-btn r130-btn--ink" data-kits-acao="recarregar">Tentar de novo</button>'
      + '<a class="r130-btn r130-btn--wa" target="_blank" rel="noopener" data-kits-na-direto="erro" href="' + esc(linkWa(msgNaoAchou(''))) + '">'
      + ico('whatsapp') + '<span>Pedir pelo WhatsApp</span></a></div></div>';
  }

  /* ---------------- passo 1: carro ---------------- */
  // Campo Motor e campo de chassi do tema (templates na seção: os mesmos do "Meu carro" e dos outros lugares).
  function campoDoTema(nome) { var t = raiz.querySelector('template[data-kits-' + nome + ']'); return t ? t.innerHTML : ''; }
  function renderCarro() {
    var c = estado.carro || {};
    var monts = indice.montadoras || [];
    var principais = monts.filter(function (m) { return m.id === 'HYUNDAI' || m.id === 'KIA'; });
    var outras = monts.filter(function (m) { return m.id !== 'HYUNDAI' && m.id !== 'KIA'; });
    function opt(v, t, sel) { return '<option value="' + esc(v) + '"' + (sel ? ' selected' : '') + '>' + esc(t) + '</option>'; }
    var html = '';
    if (estado.trocar && estado.carro && estado.carro.a) {
      html += '<button type="button" class="r130-kits__voltar" data-kits-acao="cancelar-troca">' + ico('voltar') + 'Voltar ao ' + esc(nomeCarro(estado.carro)) + '</button>';
    }
    if (estado.carro && estado.carro.mt === undefined) { var gg = carroDaGaragem(); if (gg && gg.md === estado.carro.md) estado.carro.mt = gg.mt; }
    html += '<h2 class="r130-kits__h2" data-kits-foco tabindex="-1">Qual é o seu carro?</h2>'
      + '<p class="r130-kits__intro">Escolha a montadora, o modelo, o ano e o motor. O carro fica salvo no "Meu carro" deste aparelho.</p>';
    if (garagemSemKit && !estado.carro) {
      html += '<div class="r130-kits__aviso">' + ico('alerta') + '<p>Ainda não temos kit cadastrado para o seu <strong>' + esc(garagemSemKit)
        + '</strong>. Escolha outro carro abaixo ou <a href="#r130-kits-naoachou" data-kits-acao="naoachou">peça o kit pelo WhatsApp</a>.</p></div>';
    }
    html += '<form class="r130-kits__form" data-kits-form-carro novalidate><div class="r130-kits__campos">'
      + '<div class="r130-kits__campo"><label for="r130-kits-m">Montadora</label><select id="r130-kits-m" name="m" required>'
      + opt('', 'Selecione') + principais.map(function (m) { return opt(m.id, m.nome, m.id === c.m); }).join('')
      + (outras.length ? '<optgroup label="Outras montadoras">' + outras.map(function (m) { return opt(m.id, m.nome, m.id === c.m); }).join('') + '</optgroup>' : '')
      + '</select></div>'
      + '<div class="r130-kits__campo"><label for="r130-kits-md">Modelo</label><select id="r130-kits-md" name="md" required disabled></select></div>'
      + '<div class="r130-kits__campo"><label for="r130-kits-a">Ano</label><select id="r130-kits-a" name="a" required disabled></select></div>'
      + campoDoTema('motor')
      + '</div>' + campoDoTema('chassi') + '<p class="r130-kits__erro" role="alert" hidden></p>'
      + '<button type="submit" class="r130-btn r130-btn--red">Ver os kits do meu carro</button></form>'
      + '<p class="r130-kits__intro r130-kits__intro--depois">Sabe o nome ou o código da peça? Use a busca acima.</p>'
      + linkNaoAchou() + dataLista();
    painel.innerHTML = html;
    var f = painel.querySelector('[data-kits-form-carro]');
    var sm = f.querySelector('[name="m"]'), smd = f.querySelector('[name="md"]'), sa = f.querySelector('[name="a"]');
    var erro = f.querySelector('.r130-kits__erro');
    // Motor (assets/r130-motor.js): obrigatório, ou o chassi no lugar.
    var smt = f.querySelector('[data-r130-motor-campo]'), motorCampo = null;
    function campoMotor() {
      if (!motorCampo && smt && window.R130Motor) motorCampo = window.R130Motor.campo(smt, { chassi: f.querySelector('[data-r130-chassi-campo]') });
      return motorCampo;
    }
    function preencherMotor(salvo) {
      var mc = campoMotor();
      if (!mc) return;
      var m = montadora(sm.value), md = modelo(sm.value, smd.value);
      if (!m || !md || !sa.value) { mc.limpar('Escolha o ano'); return; }
      mc.preencher(m.nome, md.nome, Number(sa.value), salvo);
    }
    function preencherModelos(mdSel) {
      var m = montadora(sm.value);
      smd.innerHTML = opt('', m ? 'Selecione' : 'Escolha a montadora') + (m ? m.modelos.map(function (x) { return opt(x.id, x.nome, x.id === mdSel); }).join('') : '');
      smd.disabled = !m;
      preencherAnos(c.a);
    }
    function preencherAnos(aSel) {
      var md = modelo(sm.value, smd.value), anos = [];
      if (md) for (var y = md.anos[1]; y >= md.anos[0]; y--) anos.push(y);
      sa.innerHTML = opt('', md ? 'Selecione' : 'Escolha o modelo') + anos.map(function (y) { return opt(y, y, y === aSel); }).join('');
      sa.disabled = !md;
      preencherMotor(c.md === smd.value && c.a === Number(sa.value) ? c.mt : '');
    }
    function avisar(msg, campo) {
      erro.textContent = msg || ''; erro.hidden = !msg;
      [sm, smd, sa, smt].forEach(function (s) { if (s) s.removeAttribute('aria-invalid'); });
      if (campo) { campo.setAttribute('aria-invalid', 'true'); campo.focus(); }
    }
    preencherModelos(c.md);
    sm.addEventListener('change', function () { avisar(''); preencherModelos(''); });
    smd.addEventListener('change', function () { avisar(''); preencherAnos(null); });
    sa.addEventListener('change', function () { avisar(''); preencherMotor(smt ? smt.value : ''); });
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (!sm.value) return avisar('Escolha a montadora.', sm);
      if (!smd.value) return avisar('Escolha o modelo.', smd);
      if (!sa.value) return avisar('Escolha o ano.', sa);
      var mc = campoMotor(), msgMotor = mc ? mc.validar() : '';
      if (msgMotor) { avisar(msgMotor, smt); mc.mostrarErro(msgMotor, true); return; }
      var novo = { m: sm.value, md: smd.value, a: Number(sa.value), mt: mc ? mc.motorParaSalvar() : '' };
      salvarGaragem(novo);
      estado.origemCarro = 'escolhido';
      garagemSemKit = null;
      ir({ carro: novo, s: null, t: null, q: '', trocar: false, guia: estado.guia == null ? null : '' });
    });
  }

  /* ---------------- passo 2: parte do carro ---------------- */
  var ICONES_SISTEMA = { susp_d: 'amortecedor', susp_t: 'bucha', susp: 'amortecedor', direcao: 'carro', motor: 'coxim',
    freio: 'freio', arrefecimento: 'arrefecimento', transmissao: 'coxim', carroceria: 'acabamento', outros: 'kit' };
  function opcao(acao, valor, icone, nome, n, extra) {
    return '<li><button type="button" class="r130-kits__opcao' + (extra || '') + '" data-kits-acao="' + acao + '" data-valor="' + esc(valor) + '">'
      + '<span class="r130-kits__opcao-ico" aria-hidden="true">' + ico(icone) + '</span>'
      + '<span class="r130-kits__opcao-txt"><span class="r130-kits__opcao-nome">' + esc(nome) + '</span><span class="r130-kits__opcao-n">' + esc(n) + '</span></span>'
      + '<span class="r130-kits__opcao-chev" aria-hidden="true">' + ico('seta') + '</span></button></li>';
  }
  function renderSemKitNoAno() {
    var c = estado.carro;
    return anosComKit(c).then(function (anos) {
      var perto = anos.slice().sort(function (x, y) { return Math.abs(x - c.a) - Math.abs(y - c.a) || y - x; }).slice(0, 8).sort(function (x, y) { return x - y; });
      painel.innerHTML = '<h2 class="r130-kits__h2" data-kits-foco tabindex="-1">Ainda não temos kit cadastrado para o ' + esc(nomeCarro(c)) + '</h2>'
        + (perto.length ? '<p class="r130-kits__intro">O ' + esc((modelo(c.m, c.md) || {}).nome) + ' tem kits cadastrados nestes anos. Se o seu é de um deles, toque no ano:</p>'
          + '<ul class="r130-kits__anos">' + perto.map(function (a) { return '<li><button type="button" data-kits-acao="ano" data-valor="' + a + '">' + a + '</button></li>'; }).join('') + '</ul>' : '')
        + '<div class="r130-kits__vazio"><p>Mande o chassi pelo WhatsApp: a equipe confere as peças e responde se temos o kit, mesmo que ele não esteja na lista.</p><div class="r130-kits__vazio-acoes">'
        + '<a class="r130-btn r130-btn--wa" target="_blank" rel="noopener" data-kits-na-direto="sem_kit_no_ano" href="' + esc(linkWa(msgNaoAchou(''))) + '">' + ico('whatsapp') + '<span>Pedir o kit pelo WhatsApp</span></a>'
        + '<button type="button" class="r130-btn r130-btn--ghost" data-kits-acao="trocar">Trocar o carro</button></div></div>' + dataLista();
      emitir('kit_finder_resultado', Object.assign(camposPasso(), { via: 'navegacao', kits: 0, vazio: true }));
    });
  }
  function renderPartes() {
    var c = estado.carro;
    return kitsDoCarro(c).then(function (lista) {
      if (!lista.length) return renderSemKitNoAno();
      var cont = {};
      lista.forEach(function (x) { x.k.s.forEach(function (s) { cont[s] = (cont[s] || 0) + 1; }); });
      var ordem = Object.keys(indice.sistemas).filter(function (s) { return cont[s]; });
      painel.innerHTML = '<h2 class="r130-kits__h2" data-kits-foco tabindex="-1">Que parte do ' + esc(nomeCarro(c)) + ' você vai reparar?</h2>'
        + '<p class="r130-kits__intro">' + esc(plural(lista.length, 'kit cadastrado', 'kits cadastrados')) + ' para este carro.</p>'
        + '<ul class="r130-kits__opcoes" role="list">'
        + ordem.map(function (s) { return opcao('parte', s, ICONES_SISTEMA[s] || 'kit', indice.sistemas[s], plural(cont[s], 'kit', 'kits')); }).join('')
        + opcao('parte', 'todos', 'kit', 'Todos os kits deste carro', plural(lista.length, 'kit', 'kits'), ' r130-kits__opcao--todos')
        + '</ul>' + linkNaoAchou() + dataLista();
    });
  }

  /* ---------------- passo 3: tipo de kit ---------------- */
  var ICONES_TOPICO = { amortecedor: 'amortecedor', mola: 'amortecedor', bieletas: 'bieleta', barra_kit: 'bieleta', pivos: 'bieleta',
    bracos: 'bieleta', bandejas: 'bieleta', coxins_motor: 'coxim', juntas: 'coxim', retentores: 'coxim', pastilhas: 'freio',
    discos: 'freio', freio_kit: 'freio', arrefecimento: 'arrefecimento', completo: 'kit', direcao: 'carro' };
  function iconeTopico(t) { return ICONES_TOPICO[t] || (/bucha|barra/.test(t) ? 'bucha' : /parach|porta|paralama|retrov|capo|roda|parabarro|carroceria/.test(t) ? 'acabamento' : 'kit'); }
  function doSistema(lista) {
    return estado.s === 'todos' ? lista : lista.filter(function (x) { return x.k.s.indexOf(estado.s) !== -1; });
  }
  function renderTipos() {
    var c = estado.carro;
    return kitsDoCarro(c).then(function (lista) {
      if (!lista.length) return renderSemKitNoAno();
      var doS = doSistema(lista);
      if (!doS.length) { estado.s = null; gravarUrl('replace'); return renderPartes(); }
      var prim = {}, sec = {};
      doS.forEach(function (x) {
        prim[x.k.t] = (prim[x.k.t] || 0) + 1;
        (x.k.tp || []).forEach(function (t) { if (t !== x.k.t) sec[t] = (sec[t] || 0) + 1; });
      });
      var ordem = (indice.ordem_topicos || Object.keys(indice.topicos)).filter(function (t) { return prim[t] || sec[t]; });
      var nomeS = indice.sistemas[estado.s] || '';
      painel.innerHTML = '<button type="button" class="r130-kits__voltar" data-kits-acao="partes">' + ico('voltar') + 'Partes do carro</button>'
        + '<h2 class="r130-kits__h2" data-kits-foco tabindex="-1">' + esc(nomeS) + ' do ' + esc(nomeCarro(c)) + ': que kit você procura?</h2>'
        + '<p class="r130-kits__intro">' + esc(plural(doS.length, 'kit', 'kits')) + ' nesta parte do carro.</p>'
        + '<ul class="r130-kits__opcoes" role="list">'
        + ordem.map(function (t) {
          var n = prim[t] ? plural(prim[t], 'kit', 'kits') + (sec[t] ? ' e mais ' + sec[t] + ' com outras peças' : '')
            : 'em ' + plural(sec[t], 'kit', 'kits') + ' com outras peças';
          return opcao('tipo', t, iconeTopico(t), indice.topicos[t] || t, n);
        }).join('')
        + '</ul>' + linkNaoAchou() + dataLista();
    });
  }

  /* ---------------- passo 4: os kits ---------------- */
  function escolherAnuncio(k, chaveModelo) {
    var a = k.a || [];
    if (!a.length) return null;
    var cita = function (x) { return chaveModelo && (x[4] || []).indexOf(chaveModelo) !== -1; };
    return a.filter(function (x) { return x[3] && cita(x); })[0] || a.filter(function (x) { return x[3]; })[0]
      || a.filter(cita)[0] || a[0];
  }
  function faixasTexto(fx) {
    var anos = fx.map(function (r) { return [r[0], r[1]]; }).sort(function (x, y) { return x[0] - y[0]; });
    var juntas = [];
    anos.forEach(function (r) {
      var u = juntas[juntas.length - 1];
      if (u && r[0] <= u[1] + 1) u[1] = Math.max(u[1], r[1]); else juntas.push([r[0], r[1]]);
    });
    return juntar(juntas.map(function (r) { return faixaTexto(r[0], r[1]); }));
  }
  function motoresTexto(fx) {
    var m = {};
    fx.forEach(function (r) { String(r[2] || '').split(/,| e /).forEach(function (x) { x = x.trim(); if (x) m[x] = 1; }); });
    var l = Object.keys(m).sort();
    return l.length ? (l.length === 1 ? 'motor ' : 'motores ') + juntar(l) : '';
  }
  function textoAplicacao(ctx) {
    var k = ctx.k;
    if (ctx.faixas) {
      var md = modelo(estado.carro.m, estado.carro.md);
      var t = (md ? md.nome + ' ' : '') + faixasTexto(ctx.faixas);
      var mt = motoresTexto(ctx.faixas);
      return t + (mt ? ', ' + mt : '');
    }
    var porModelo = {};
    (ctx.aplic || []).forEach(function (r) { (porModelo[r[0]] = porModelo[r[0]] || []).push([r[1], r[2], r[3]]); });
    var nomes = Object.keys(porModelo).map(function (km) { return nomeModeloChave(km) + ' ' + faixasTexto(porModelo[km]); });
    return nomes.length > 3 ? nomes.slice(0, 3).join(', ') + ' e mais ' + plural(nomes.length - 3, 'carro', 'carros') : juntar(nomes);
  }
  // Foto do cartão (agente kit-guia, 19/10/2026; pedido do Marcus: "ficar ainda melhor se tivesse a imagem dos
  // anúncios"): a foto principal do anúncio do kit; sem anúncio, as fotos dos anúncios das peças do kit (até 4, cada
  // uma do próprio código, nunca de outra peça); sem nenhuma, o ícone do tipo. JSON: caminho curto + indice.img_base.
  function urlImg(p, largura) {
    if (!p) return '';
    var base = p.charAt(0) === '/' ? 'https://cdn.shopify.com' : (indice && indice.img_base) || '';
    return base ? base + p + (p.indexOf('?') === -1 ? '?' : '&') + 'width=' + largura : '';
  }
  function midiaKit(k, d, an) {
    var foto = an ? urlImg(an[5], 176) : '';
    if (foto) return '<div class="r130-kits__midia r130-kits__midia--1"><img src="' + esc(foto) + '" alt="' + esc(k.n)
      + '" width="88" height="88" loading="lazy" decoding="async"></div>';
    var fotos = [];
    k.c.forEach(function (c) {
      var p = d.pecas[c[0]] || [];
      if (p[3] && fotos.length < 4 && urlImg(p[3], 96) && !fotos.some(function (f) { return f[0] === p[3]; })) fotos.push([p[3], p[0] || 'Peça']);
    });
    if (!fotos.length) return '<div class="r130-kits__midia r130-kits__midia--ico" aria-hidden="true">' + ico(iconeTopico(k.t)) + '</div>';
    return '<div class="r130-kits__midia r130-kits__midia--' + fotos.length + '">' + fotos.map(function (f) {
      var t = fotos.length === 1 ? 88 : 44;
      return '<img src="' + esc(urlImg(f[0], fotos.length === 1 ? 176 : 96)) + '" alt="' + esc(f[1]) + '" width="' + t + '" height="' + t
        + '" loading="lazy" decoding="async">';
    }).join('') + '</div>';
  }
  function cartao(ctx, n) {
    var k = ctx.k, d = ctx.d;
    var chaveMod = estado.carro ? estado.carro.m + '|' + estado.carro.md : (ctx.aplic && ctx.aplic[0] ? ctx.aplic[0][0] : '');
    var an = escolherAnuncio(k, chaveMod);
    var comprar = !!(an && an[3] && k.e);
    var pecas = k.c.reduce(function (s, c) { return s + (c[1] || 0); }, 0);
    var id = 'r130-kits-k' + n;
    var h = '<li><article class="r130-kits__card" aria-labelledby="' + id + '">';
    var marcas = [];
    k.c.forEach(function (c) { var mc = (d.pecas[c[0]] || [])[2]; if (mc && marcas.indexOf(mc) === -1) marcas.push(mc); });
    h += '<div class="r130-kits__cab">' + midiaKit(k, d, an) + '<div class="r130-kits__cab-txt">';
    h += '<div class="r130-kits__selos">' + (k.e ? '<span class="r130-kits__selo r130-kits__selo--ok">Em estoque</span>' : '<span class="r130-kits__selo r130-kits__selo--consulta">Sob consulta</span>')
      + '<span class="r130-kits__selo r130-kits__selo--info">' + esc(plural(pecas, 'peça', 'peças')) + '</span>'
      + (marcas.length ? '<span class="r130-kits__selo r130-kits__selo--info">' + esc(marcas.join(' + ')) + '</span>' : '') + '</div>';
    h += '<h3 class="r130-kits__card-h3" id="' + id + '">' + esc(k.n) + '</h3>';
    h += '</div></div>';
    var apl = textoAplicacao(ctx);
    if (k.f === 'c' && ctx.motor && ctx.motor.outro) h += '<p class="r130-kits__fit r130-kits__fit--chassi">' + ico('alerta') + '<span><strong>Confirme pelo chassi.</strong> '
      + 'A aplicação cadastrada é para o motor ' + esc(juntar(ctx.motor.motores)) + ', não para o ' + esc(ctx.motor.cliente) + ' (' + esc(apl) + ').</span></p>';
    else if (k.f === 'c') h += '<p class="r130-kits__fit r130-kits__fit--ok">' + ico('check') + '<span>Aplicação cadastrada: ' + esc(apl) + '.</span></p>';
    else h += '<p class="r130-kits__fit r130-kits__fit--chassi">' + ico('alerta') + '<span><strong>Confirme pelo chassi.</strong> '
      + (k.f === 'p' ? 'Uma das peças não tem a aplicação cadastrada' : 'O carro vem do nome do kit, sem aplicação cadastrada')
      + (apl ? ' (' + esc(apl) + ')' : '') + '.</span></p>';
    h += '<p class="r130-kits__itens-tit">O que vem no kit</p><ul class="r130-kits__itens">' + k.c.map(function (c) {
      var p = d.pecas[c[0]] || [];
      var det = [p[1] ? 'cód. original ' + p[1] : '', p[2] || ''].filter(Boolean).join(' · ');  // código interno só no WhatsApp (decisão do Marcus, 19/10)
      return '<li><span class="r130-kits__qtd">' + c[1] + '×</span><span>' + esc(p[0] || 'Peça') + '<span class="r130-kits__cod">' + esc(det) + '</span></span></li>';
    }).join('') + '</ul>';
    h += '<div class="r130-kits__rodape">';
    var wa = '<a class="r130-btn r130-btn--wa" target="_blank" rel="noopener" data-kits-wa="' + esc(k.id) + '" href="' + esc(linkWa(msgKit(ctx, an))) + '">'
      + ico('whatsapp') + '<span>Pedir pelo WhatsApp</span></a>';
    if (an) {
      h += '<p class="r130-kits__preco">' + dinheiro(an[2]) + '<small>preço no site</small></p>';
      if (comprar) {
        h += '<button type="button" class="r130-btn r130-btn--red" data-kits-add="' + an[1] + '" data-kit="' + esc(k.id) + '" data-preco="' + an[2] + '">'
          + ico('carrinho') + '<span>Adicionar ao carrinho</span></button>'
          + '<p class="r130-kits__msg" role="status" hidden></p>' + wa;   // WhatsApp com o mesmo peso (prioridade do Marcus, 19/10)
      } else {
        h += wa;
      }
      h += '<a class="r130-kits__link" href="/products/' + esc(an[0]) + '">Ver o kit no site</a>';
    } else {
      h += wa + '<p class="r130-kits__cod">Este kit ainda não está à venda no site: o vendedor passa o preço e o prazo.</p>';
    }
    h += '</div></article></li>';
    return h;
  }
  function grade(lista, inicio) {
    return '<ul class="r130-kits__grade" role="list">' + lista.map(function (x, i) { return cartao(x, (inicio || 0) + i); }).join('') + '</ul>';
  }
  function resumoLista(l) {
    var est = l.filter(function (x) { return x.k.e; }).length;
    var site = l.filter(function (x) { return x.k.a && x.k.a.length; }).length;
    return plural(l.length, 'kit', 'kits') + ' · ' + est + ' em estoque · ' + plural(site, 'à venda no site', 'à venda no site');
  }
  function renderResultado() {
    var c = estado.carro;
    return kitsDoCarro(c).then(function (lista) {
      if (!lista.length) return renderSemKitNoAno();
      var doS = doSistema(lista);
      var prim = estado.s === 'todos' ? doS : doS.filter(function (x) { return x.k.t === estado.t; });
      var sec = estado.s === 'todos' ? [] : doS.filter(function (x) { return x.k.t !== estado.t && (x.k.tp || []).indexOf(estado.t) !== -1; });
      if (!prim.length && !sec.length) { estado.t = null; gravarUrl('replace'); return renderTipos(); }
      var todos = prim.concat(sec), mostrar = todos.slice(0, estado.n);
      var tit = estado.s === 'todos' ? 'Todos os kits do ' + nomeCarro(c) : indice.topicos[estado.t] || estado.t;
      var sub = estado.s === 'todos' ? '' : (indice.sistemas[estado.s] || '') + ' do ' + nomeCarro(c, true) + ' · ';
      var h = '<button type="button" class="r130-kits__voltar" data-kits-acao="' + (estado.s === 'todos' ? 'partes' : 'tipos') + '">' + ico('voltar')
        + (estado.s === 'todos' ? 'Partes do carro' : 'Tipos de kit') + '</button>'
        + '<h2 class="r130-kits__h2" data-kits-foco tabindex="-1">' + esc(tit) + '</h2>'
        + '<p class="r130-kits__resumo">' + esc(sub + resumoLista(todos)) + '</p>';
      var mp = mostrar.filter(function (x) { return prim.indexOf(x) !== -1; });
      var ms = mostrar.filter(function (x) { return sec.indexOf(x) !== -1; });
      if (mp.length) h += grade(mp, 0);
      if (ms.length) h += '<p class="r130-kits__divisor">' + (mp.length ? 'Também vêm em kits com outras peças' : 'Vêm em kits com outras peças') + '</p>' + grade(ms, mp.length);
      if (todos.length > mostrar.length) h += '<div class="r130-kits__mais"><button type="button" class="r130-btn r130-btn--ghost" data-kits-acao="mais">Mostrar mais '
        + plural(Math.min(POR_PAGINA, todos.length - mostrar.length), 'kit', 'kits') + ' (de ' + (todos.length - mostrar.length) + ')</button></div>';
      h += linkNaoAchou() + dataLista();
      painel.innerHTML = h;
      emitir('kit_finder_resultado', Object.assign(camposPasso(), { via: 'navegacao', kits: todos.length,
        em_estoque: todos.filter(function (x) { return x.k.e; }).length,
        com_anuncio: todos.filter(function (x) { return x.k.a && x.k.a.length; }).length, vazio: false }));
    });
  }

  /* ---------------- busca ---------------- */
  function termosDe(q, carro) {
    var md = carro && modelo(carro.m, carro.md);
    var doCarro = {};
    if (md) palavras(md.nome + ' ' + (montadora(carro.m) || {}).nome).forEach(function (w) { doCarro[w] = 1; });
    return semAcento(q).toLowerCase().split(/[\s,;/]+/).filter(Boolean).map(function (tok) {
      tok = tok.replace(/^[^a-z0-9]+|[^a-z0-9-]+$/g, '');
      if (!tok || VAZIAS[tok]) return null;
      if (/^(19|20)\d\d$/.test(tok)) return carro ? null : { ano: Number(tok) };
      if (/\d/.test(tok) && chave(tok).length >= 4) return { cod: chave(tok) };
      var w = radical(tok.replace(/-/g, ''));
      if (w.length < 2 || doCarro[w]) return null;
      return { w: w };
    }).filter(Boolean);
  }
  function palheiro(x) {
    var k = x.k;
    if (k._h && (!x.aplic || k._hModelos)) return k._h;
    var partes = [k.n, indice.topicos[k.t] || ''];
    (k.tp || []).forEach(function (t) { partes.push(indice.topicos[t] || ''); });
    k.s.forEach(function (s) { partes.push(indice.sistemas[s] || ''); });
    var cods = [k.id];
    k.c.forEach(function (c) { var p = x.d.pecas[c[0]] || []; partes.push(p[0] || '', p[2] || ''); cods.push(c[0]); if (p[1]) cods.push(p[1]); });
    if (x.aplic) { x.aplic.forEach(function (r) { partes.push(nomeModeloChave(r[0])); }); k._hModelos = 1; }
    k._h = { w: palavras(partes.join(' ')), c: ' ' + cods.map(chave).join(' ') };
    return k._h;
  }
  function casa(x, termos) {
    var h = palheiro(x);
    return termos.every(function (t) {
      if (t.cod) return h.c.indexOf(t.cod) !== -1;
      if (t.ano) return (x.aplic || []).some(function (r) { return r[1] <= t.ano && t.ano <= r[2]; });
      return h.w.some(function (w) { return w.indexOf(t.w) === 0; });
    });
  }
  // Todos os kits de todos os arquivos (busca sem carro): um por código, com as aplicações de todos os carros.
  function todosOsKits() {
    var nomes = {};
    (indice.montadoras || []).forEach(function (m) { nomes[m.arquivo] = 1; });
    return Promise.all(Object.keys(nomes).map(carregarArquivo)).then(function (ds) {
      var por = {}, out = [];
      ds.forEach(function (d) {
        d.kits.forEach(function (k, i) {
          var ap = d.porKit[i] || [];
          if (por[k.id]) { por[k.id].aplic = por[k.id].aplic.concat(ap); return; }
          por[k.id] = { k: k, d: d, aplic: ap.slice(), i: i };
          out.push(por[k.id]);
        });
      });
      out.sort(function (x, y) { return (y.k.e - x.k.e) || (compravel(y.k) - compravel(x.k)) || (y.k.o - x.k.o) || (x.k.id < y.k.id ? -1 : 1); });
      return out;
    });
  }
  function renderBusca() {
    var c = estado.carro && estado.carro.a && !estado.todos ? estado.carro : null;
    var termos = termosDe(estado.q, c);
    var fonte = c ? kitsDoCarro(c) : todosOsKits();
    return fonte.then(function (lista) {
      var achados = termos.length ? lista.filter(function (x) { return casa(x, termos); }) : [];
      if (termos.length) {
        // primeiro os que têm as palavras no próprio nome do kit
        var noNome = function (x) { var w = palavras(x.k.n); return termos.every(function (t) { return !t.w || w.some(function (p) { return p.indexOf(t.w) === 0; }); }) ? 0 : 1; };
        achados = achados.map(function (x, i) { return [noNome(x), i, x]; }).sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; }).map(function (a) { return a[2]; });
      }
      var mostrar = achados.slice(0, estado.n);
      var onde = c ? ' no ' + nomeCarro(c) : ' em todos os carros';
      var h = '<button type="button" class="r130-kits__voltar" data-kits-acao="limpar-busca">' + ico('voltar') + (estado.carro && estado.carro.a ? 'Partes do carro' : 'Voltar') + '</button>'
        + '<h2 class="r130-kits__h2" data-kits-foco tabindex="-1">Busca: “' + esc(estado.q) + '”</h2>';
      if (!achados.length) {
        h += '<div class="r130-kits__vazio"><p>' + (termos.length ? 'Não achamos kit com “' + esc(estado.q) + '”' + esc(onde) + '.' : 'Digite o nome da peça ou o código.') + '</p>'
          + '<div class="r130-kits__vazio-acoes">'
          + (c ? '<button type="button" class="r130-btn r130-btn--ink" data-kits-acao="buscar-todos">Buscar em todos os carros</button>' : '')
          + '<a class="r130-btn r130-btn--wa" target="_blank" rel="noopener" data-kits-na-direto="busca" href="' + esc(linkWa(msgNaoAchou(estado.q))) + '">'
          + ico('whatsapp') + '<span>Pedir pelo WhatsApp</span></a></div></div>' + dataLista();
        painel.innerHTML = h;
      } else {
        h += '<p class="r130-kits__resumo">' + esc(plural(achados.length, 'kit encontrado', 'kits encontrados') + onde) + '.'
          + (c ? ' <button type="button" class="r130-kits__linkbtn" data-kits-acao="buscar-todos">Buscar em todos os carros</button>' : '') + '</p>'
          + grade(mostrar, 0);
        if (achados.length > mostrar.length) h += '<div class="r130-kits__mais"><button type="button" class="r130-btn r130-btn--ghost" data-kits-acao="mais">Mostrar mais '
          + plural(Math.min(POR_PAGINA, achados.length - mostrar.length), 'kit', 'kits') + ' (de ' + (achados.length - mostrar.length) + ')</button></div>';
        painel.innerHTML = h + linkNaoAchou() + dataLista();
      }
      var anon = window.R130Medicao && window.R130Medicao.anonimizar ? window.R130Medicao.anonimizar(estado.q) : '';
      emitir('kit_finder_resultado', Object.assign(camposPasso(), { via: 'busca', termo: anon, escopo: c ? 'carro' : 'todos',
        kits: achados.length, em_estoque: achados.filter(function (x) { return x.k.e; }).length,
        com_anuncio: achados.filter(function (x) { return x.k.a && x.k.a.length; }).length, vazio: !achados.length }));
    });
  }

  /* ---------------- WhatsApp ---------------- */
  function msgKit(ctx, an) {
    var k = ctx.k, l = [];
    l.push('Olá! Vi no site, em Kits por carro, e quero este kit:');
    l.push('*' + k.n + '* (código ' + k.id + ')');
    l.push('O que vem:');
    k.c.forEach(function (c) {
      var p = ctx.d.pecas[c[0]] || [];
      l.push('- ' + c[1] + 'x ' + (p[0] || 'Peça') + ' (' + c[0] + (p[1] ? ', cód. original ' + p[1] : '') + ')');
    });
    l.push('Meu carro: ' + (estado.carro && estado.carro.a ? nomeCarro(estado.carro, true) : ''));
    if (an) l.push('Kit no site: ' + LOJA + '/products/' + an[0]);
    l.push(k.e ? (an ? 'Pode conferir a aplicação no meu carro?' : 'Pode conferir a aplicação no meu carro e passar o preço e o prazo?')
      : 'No site ele aparece como sob consulta. Tem previsão ou outra opção?');
    var rg = estado.guia != null && window.R130KitsGuia ? window.R130KitsGuia.resumoCurto() : '';
    if (rg) l.push(rg);
    l.push('Chassi:');
    return l.join('\n');
  }
  function contextoTela() {
    var p = passoAtual();
    if (p === 'busca') return 'Busquei: ' + estado.q;
    if (p === 'guia' && window.R130KitsGuia) return window.R130KitsGuia.resumoCurto();
    var partes = [];
    if (estado.s) partes.push(estado.s === 'todos' ? 'Todos os kits' : indice.sistemas[estado.s]);
    if (estado.t) partes.push(indice.topicos[estado.t]);
    return partes.length ? 'Estava vendo: ' + partes.join(' > ') : '';
  }
  function msgNaoAchou(pedido) {
    var c = estado.carro && estado.carro.a ? nomeCarro(estado.carro, true) : '';
    var l = ['Olá! Não achei no site o kit que preciso.'];
    l.push('Meu carro' + (c ? ': ' + c : ' (modelo e ano):'));
    l.push('O que preciso: ' + String(pedido || '').trim());
    var ctx = indice ? contextoTela() : '';
    if (ctx) l.push(ctx);
    l.push('Chassi:');
    return l.join('\n');
  }
  function atualizarNaoAchou() {
    if (!na) return;
    var p = na.querySelector('[data-kits-na-carro]');
    var c = estado.carro && estado.carro.a ? nomeCarro(estado.carro, true) : '';
    if (p) { p.hidden = !c; p.innerHTML = c ? 'Seu carro: <strong>' + esc(c) + '</strong>' : ''; }
    var campo = na.querySelector('textarea'), a = na.querySelector('[data-kits-na-wa]');
    if (a) a.href = linkWa(msgNaoAchou(campo ? campo.value : ''));
  }

  /* ---------------- carrinho ---------------- */
  function adicionar(b) {
    var variante = parseInt(b.getAttribute('data-kits-add'), 10);
    var msg = b.parentNode.querySelector('.r130-kits__msg');
    if (!variante || b.disabled) return;
    b.disabled = true; b.setAttribute('aria-busy', 'true');
    if (msg) { msg.hidden = true; msg.textContent = ''; }
    var corpo = { items: [{ id: variante, quantity: 1 }] };
    var feito;
    if (window.R130Carrinho && typeof window.R130Carrinho.adicionar === 'function') {
      feito = Promise.resolve(window.R130Carrinho.adicionar(corpo)).then(function (item) { return !!item; });
    } else {
      feito = fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corpo) })
        .then(function (r) { if (!r.ok) return false; location.href = '/cart'; return true; });
    }
    feito.then(function (ok) {
      if (ok) {
        var valor = (parseInt(b.getAttribute('data-preco'), 10) || 0) / 100;
        emitir('kit_adicionar', { kit: b.getAttribute('data-kit'), valor: valor, contexto: estado.guia != null ? 'kits_guia' : 'localizador', parte: estado.s || '', tipo: estado.t || '' });
      } else if (msg) {
        msg.textContent = 'Não deu para adicionar agora. Tente de novo ou peça pelo WhatsApp.'; msg.hidden = false;
      }
    }).catch(function () {
      if (msg) { msg.textContent = 'Não deu para adicionar agora. Tente de novo ou peça pelo WhatsApp.'; msg.hidden = false; }
    }).then(function () { b.disabled = false; b.removeAttribute('aria-busy'); });
  }

  /* ---------------- cliques e campos ---------------- */
  raiz.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target : null;
    if (!t) return;
    var add = t.closest('[data-kits-add]');
    if (add) { ev.preventDefault(); adicionar(add); return; }
    var wa = t.closest('[data-kits-wa]');
    if (wa) {
      var kid = wa.getAttribute('data-kits-wa');
      var card = wa.closest('.r130-kits__card');
      emitir('kit_finder_whatsapp', { kit: kid, tem_anuncio: !!(card && card.querySelector('.r130-kits__preco')),
        em_estoque: !!(card && card.querySelector('.r130-kits__selo--ok')), parte: estado.s || '', tipo: estado.t || '', via: passoAtual() });
      return;
    }
    var direto = t.closest('[data-kits-na-direto]');
    if (direto) { emitir('kit_finder_nao_achou', Object.assign(camposPasso(), { via: direto.getAttribute('data-kits-na-direto'), tem_texto: !!estado.q })); return; }
    var el = t.closest('[data-kits-acao]');
    if (!el) return;
    var acao = el.getAttribute('data-kits-acao'), v = el.getAttribute('data-valor');
    if (acao === 'naoachou') {
      ev.preventDefault();
      var campo = na && na.querySelector('textarea');
      if (campo) { focar(campo, true); } else if (na) na.scrollIntoView();
      return;
    }
    ev.preventDefault();
    if (acao === 'parte') ir({ s: v, t: null });
    else if (acao === 'tipo') ir({ t: v });
    else if (acao === 'partes') ir({ s: null, t: null, q: '', todos: false, guia: null });
    else if (acao === 'tipos') ir({ t: null });
    else if (acao === 'trocar') ir({ trocar: true, q: '' });
    else if (acao === 'cancelar-troca') ir({ trocar: false });
    else if (acao === 'ano') { var novo = { m: estado.carro.m, md: estado.carro.md, a: Number(v) }; salvarGaragem(novo); ir({ carro: novo, s: null, t: null }); }
    else if (acao === 'limpar-busca') { if (campoBusca) campoBusca.value = ''; ir({ q: '', todos: false }); }
    else if (acao === 'buscar-todos') ir({ todos: true });
    else if (acao === 'mais') {
      var antes = painel.querySelectorAll('.r130-kits__card').length;
      estado.n += POR_PAGINA;
      silencio = true;
      render(false).then(function () {
        silencio = false;
        var cards = painel.querySelectorAll('.r130-kits__card');
        if (cards[antes]) { cards[antes].setAttribute('tabindex', '-1'); focar(cards[antes], false); }
      });
    } else if (acao === 'recarregar') { iniciar(); }
  });

  if (formBusca) formBusca.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var q = (campoBusca.value || '').trim().slice(0, 80);
    if (!indice) return;
    if (!q) { if (estado.q) ir({ q: '', todos: false }); else focar(campoBusca, false); return; }
    ir({ q: q, todos: false, trocar: false, guia: null });
  });

  if (na) {
    var campoNa = na.querySelector('textarea');
    var aNa = na.querySelector('[data-kits-na-wa]');
    if (campoNa) campoNa.addEventListener('input', atualizarNaoAchou);
    // O link já está pronto (o 'input' do campo o atualiza). Não reescrever o href aqui: o r130-chassi.js põe o chassi
    // na fase de captura, antes deste clique, e reescrever apagaria o chassi.
    if (aNa) aNa.addEventListener('click', function () {
      emitir('kit_finder_nao_achou', Object.assign(camposPasso(), { via: 'formulario', tem_texto: !!(campoNa && campoNa.value.trim()) }));
    });
  }

  window.addEventListener('popstate', function () {
    if (!indice) return;
    aplicarUrl(lerUrl());
    render(false);
  });
  // Carro trocado no "Meu carro" (header ou barra do celular) com a página aberta.
  document.addEventListener('r130:garagem', function () {
    if (!indice) return;
    var g = carroDaGaragem();
    if (g && g.a) { estado.origemCarro = 'meu_carro'; ir({ carro: g, s: null, t: null, q: '', trocar: false, guia: estado.guia == null ? null : '' }); }
    else { render(false); }
  });

  /* ---------------- perguntas guiadas (agente kit-guia, 19/10/2026: assets/r130-kits-guia.js) ---------------- */
  window.R130Kits = {
    estado: function () { return estado; }, indice: function () { return indice; }, painel: painel, ir: ir,
    redesenhar: function () { return render(false); }, kitsDoCarro: kitsDoCarro, grade: grade, nomeCarro: nomeCarro,
    montadora: montadora, modelo: modelo, ico: ico, dataLista: dataLista
  };

  /* ---------------- início ---------------- */
  window.R130Kits.urlImg = urlImg;   // foto das peças nas perguntas (agente kit-guia)
  function iniciar() {
    painel.setAttribute('aria-busy', 'true');
    return carregarIndice().then(function () {
      var u = lerUrl();
      aplicarUrl(u);
      if (estado.carro) estado.origemCarro = 'link';
      else {
        var g = carroDaGaragem();
        if (g) { estado.carro = g; estado.origemCarro = 'meu_carro'; }
      }
      gravarUrl('replace');
      return render(false);
    }).catch(function () {
      painel.setAttribute('aria-busy', 'false');
      painel.innerHTML = erroCarga();
    });
  }
  if (!URL_INDICE) { painel.innerHTML = erroCarga(); return; }
  iniciar();
})();
